export const sampleSearchResultsWithDetails = [
  {
    youtubeId: '3afXXsJwYZo',
    title: 'Wolfmother - Joker and the Thief',
    channel: 'WolfmotherMusic',
    duration: 260,
    views: 16790663,
    uploadedAt: '2009-07-11T00:39:35Z',
  },
  {
    youtubeId: 'IRsc57nK8mg',
    title: 'Wolfmother - Woman (Official Video)',
    channel: 'WolfmotherVEVO',
    duration: 182,
    views: 6597714,
    uploadedAt: '2009-11-30T23:34:50Z',
  },
  {
    youtubeId: 'Nr0SqIAFohk',
    title: 'Wolfmother - Joker And The Thief (Audio)',
    channel: 'WolfmotherVEVO',
    duration: 281,
    views: 3563268,
    uploadedAt: '2021-10-08T13:00:10Z',
  },
  {
    youtubeId: 'YsfInnEBYHw',
    title: 'Wolfmother - Woman (Audio)',
    channel: 'WolfmotherVEVO',
    duration: 177,
    views: 656270,
    uploadedAt: '2021-09-23T14:00:27Z',
  },
  {
    youtubeId: 'iDhx2eJVr4M',
    title: 'Wolfmother - White Unicorn (Official Video)',
    channel: 'WolfmotherVEVO',
    duration: 215,
    views: 2190787,
    uploadedAt: '2009-06-26T19:31:41Z',
  },
  {
    youtubeId: 'bjJ7KCBykVU',
    title: 'Wolfmother - Dimension (Official Video)',
    channel: 'WolfmotherVEVO',
    duration: 263,
    views: 4777410,
    uploadedAt: '2009-06-26T19:26:29Z',
  },
  {
    youtubeId: 'V0NpbmRcDvs',
    title: '10,000 Feet',
    channel: 'Wolfmother - Topic',
    duration: 249,
    views: 707213,
    uploadedAt: '2018-07-24T17:24:40Z',
  },
  {
    youtubeId: 'V1Yydg3XmV4',
    title: 'Colossal',
    channel: 'Wolfmother - Topic',
    duration: 305,
    views: 654504,
    uploadedAt: '2018-07-28T17:36:32Z',
  },
  {
    youtubeId: 'rcRzMZRZjcM',
    title: 'Sundial',
    channel: 'Wolfmother - Topic',
    duration: 228,
    views: 714645,
    uploadedAt: '2018-07-24T17:04:19Z',
  },
  {
    youtubeId: '-sHWUQJ6iQI',
    title: 'Wolfmother - White Unicorn (Audio)',
    channel: 'WolfmotherVEVO',
    duration: 305,
    views: 161684,
    uploadedAt: '2021-09-30T14:00:00Z',
  },
  {
    youtubeId: 'PZDg_MLmp7M',
    title: 'Wolfmother - Victorious (Official Video)',
    channel: 'WolfmotherVEVO',
    duration: 288,
    views: 3100671,
    uploadedAt: '2016-01-26T14:00:00Z',
  },
  {
    youtubeId: '2rGaICcf21I',
    title: 'Wolfmother - Love Train (Full Length)',
    channel: 'WolfmotherVEVO',
    duration: 180,
    views: 3632306,
    uploadedAt: '2009-11-20T19:15:29Z',
  },
  {
    youtubeId: 'ZKDvJTxZDbA',
    title: 'Mike Patton Puts Wolfmother In Their Place',
    channel: 'MetalChickenDragon',
    duration: 80,
    views: 898541,
    uploadedAt: '2007-10-07T21:02:12Z',
  },
  {
    youtubeId: '9kRQQimPgn8',
    title: 'Eye Of The Beholder',
    channel: 'Wolfmother - Topic',
    duration: 240,
    views: 304789,
    uploadedAt: '2018-07-26T21:13:51Z',
  },
  {
    youtubeId: '-O63P9Ecujc',
    title: 'Wolfmother - New Moon Rising',
    channel: 'WolfmotherVEVO',
    duration: 225,
    views: 3982826,
    uploadedAt: '2009-11-24T12:53:44Z',
  },
  {
    youtubeId: 'HyHNuVaZJ-k',
    title: 'Gorillaz - Feel Good Inc. (Official Video)',
    channel: 'Gorillaz',
    duration: 254,
    views: 985857304,
    uploadedAt: '2016-06-28T12:53:12Z',
  },
  {
    youtubeId: '1V_xRb0x9aw',
    title: 'Gorillaz - Clint Eastwood (Official Video)',
    channel: 'Gorillaz',
    duration: 269,
    views: 905998845,
    uploadedAt: '2016-06-28T12:18:36Z',
  },
  {
    youtubeId: 'uAOR6ib95kQ',
    title: 'Gorillaz - DARE (Official Video)',
    channel: 'Gorillaz',
    duration: 288,
    views: 334573257,
    uploadedAt: '2010-09-07T23:17:19Z',
  },
  {
    youtubeId: 'WXR-bCF5dbM',
    title: 'Gorillaz - 19-2000 (Official Video)',
    channel: 'Gorillaz',
    duration: 236,
    views: 178621629,
    uploadedAt: '2016-06-28T12:06:28Z',
  },
  {
    youtubeId: '04mfKJWDSzI',
    title: 'Gorillaz - On Melancholy Hill (Official Video)',
    channel: 'Gorillaz',
    duration: 267,
    views: 276538023,
    uploadedAt: '2010-06-14T08:36:39Z',
  },
  {
    youtubeId: 'yYDmaexVHic',
    title:
      'Gorillaz - Rhinestone Eyes [Storyboard Film] (Official Music Video)',
    channel: 'Gorillaz',
    duration: 204,
    views: 105057013,
    uploadedAt: '2010-10-04T12:13:08Z',
  },
  {
    youtubeId: 'nhPaWIeULKk',
    title: 'Gorillaz - Stylo (Official Video)',
    channel: 'Gorillaz',
    duration: 303,
    views: 154981377,
    uploadedAt: '2010-09-07T23:11:53Z',
  },
  {
    youtubeId: 'lRlmM88zzbY',
    title: 'Gorillaz - Rock The House (Official Video)',
    channel: 'Gorillaz',
    duration: 223,
    views: 71138739,
    uploadedAt: '2010-01-15T06:09:43Z',
  },
  {
    youtubeId: 'cLnkQAeMbIM',
    title: 'Gorillaz - Dirty Harry (Official Video)',
    channel: 'Gorillaz',
    duration: 301,
    views: 187022335,
    uploadedAt: '2010-09-07T23:13:27Z',
  },
  {
    youtubeId: 'BGn2oo-0Dqc',
    title: 'On Melancholy Hill',
    channel: 'Gorillaz - Topic',
    duration: 209,
    views: 17946253,
    uploadedAt: '2017-01-25T20:11:54Z',
  },
  {
    youtubeId: 'E5yFcdPAGv0',
    title: 'Gorillaz - Humility (Official Video)',
    channel: 'Gorillaz',
    duration: 201,
    views: 126927500,
    uploadedAt: '2018-05-31T15:57:04Z',
  },
  {
    youtubeId: 'S03T47hapAc',
    title: 'Gorillaz - Cracker Island ft. Thundercat (Official Video)',
    channel: 'Gorillaz',
    duration: 219,
    views: 52603744,
    uploadedAt: '2022-07-28T16:00:11Z',
  },
  {
    youtubeId: 'f8NwLXYIHS4',
    title: 'Gorillaz - She&#39;s My Collar [HQ]',
    channel: 'SalvaMuñox',
    duration: 211,
    views: 2816559,
    uploadedAt: '2020-06-18T05:44:00Z',
  },
  {
    youtubeId: '5qJp6xlKEug',
    title: 'Gorillaz - Saturnz Barz (Spirit House)',
    channel: 'Gorillaz',
    duration: 374,
    views: 130963984,
    uploadedAt: '2017-03-23T19:28:28Z',
  },
  {
    youtubeId: 'PiNdcBg3xC8',
    title: 'Gorillaz - Tomorrow Comes Today (Official Video)',
    channel: 'Gorillaz',
    duration: 195,
    views: 115321389,
    uploadedAt: '2010-01-15T15:32:42Z',
  },
  {
    youtubeId: 'qFfnlYbFEiE',
    title:
      'The Jimi Hendrix Experience - Voodoo Child (Slight Return) (Live In Maui, 1970)',
    channel: 'JimiHendrixVEVO',
    duration: 375,
    views: 54156494,
    uploadedAt: '2020-09-10T07:00:11Z',
  },
  {
    youtubeId: 'TLV4_xaYynY',
    title:
      'The Jimi Hendrix Experience - All Along The Watchtower (Official Audio)',
    channel: 'JimiHendrixVEVO',
    duration: 242,
    views: 256941940,
    uploadedAt: '2012-10-05T07:00:10Z',
  },
  {
    youtubeId: 'gUPifXX0foU',
    title: 'The Jimi Hendrix Experience - Hey Joe (1967)',
    channel: 'Beat-Club',
    duration: 252,
    views: 16033444,
    uploadedAt: '2021-11-01T15:23:58Z',
  },
  {
    youtubeId: 'HwnLuLAFPyI',
    title: 'Dim4ou - &quot;Jimy Hendrix&quot;',
    channel: 'Dim4ou',
    duration: 232,
    views: 3862971,
    uploadedAt: '2013-07-02T16:17:36Z',
  },
  {
    youtubeId: 'fTCID7fQSQc',
    title:
      'The Jimi Hendrix Experience &quot;All Along the Watchtower&quot; performed by The Classic Rock Show',
    channel: 'The Classic Rock Show',
    duration: 381,
    views: 7525496,
    uploadedAt: '2018-10-08T12:05:37Z',
  },
  {
    youtubeId: 'WGoDaYjdfSg',
    title: 'The Jimi Hendrix Experience - Purple Haze (Official Audio)',
    channel: 'JimiHendrixVEVO',
    duration: 173,
    views: 24341349,
    uploadedAt: '2019-11-12T21:48:16Z',
  },
  {
    youtubeId: '_PVjcIO4MT4',
    title: 'The Jimi Hendrix Experience - Foxey Lady (Miami Pop 1968)',
    channel: 'JimiHendrixVEVO',
    duration: 269,
    views: 59994250,
    uploadedAt: '2013-11-05T08:00:02Z',
  },
  {
    youtubeId: 'cBRoTWg0NHE',
    title:
      'When Jimi Hendrix Was Asked Who Is The Greatest Guitar Player #hendrix #jimihendrix #rorygallagher',
    channel: 'The Guitar Music Channel',
    duration: 50,
    views: 154010,
    uploadedAt: '2024-10-17T19:01:38Z',
  },
  {
    youtubeId: '3kQEzcDc02o',
    title: 'Jimi Hendrix - Hey Joe',
    channel: "Cosmic Soul's Music Channel",
    duration: 208,
    views: 27,
    uploadedAt: '2025-05-18T10:11:43Z',
  },
  {
    youtubeId: 'P701paKEMXs',
    title: 'Jimi Hendrix On An Acoustic Guitar (only known 2 videos RARE)',
    channel: 'Echelon Entertainment',
    duration: 404,
    views: 24719913,
    uploadedAt: '2017-12-09T03:20:44Z',
  },
  {
    youtubeId: 'CVO1V0GkHMM',
    title: 'I Tried Jimi Hendrix&#39;s Practice Routine #shorts',
    channel: 'Mikey Piscopo',
    duration: 56,
    views: 1415238,
    uploadedAt: '2022-12-01T19:16:51Z',
  },
  {
    youtubeId: '35luFxHO5E0',
    title: 'The Jimi Hendrix Experience - Little Wing (Official Audio)',
    channel: 'JimiHendrixVEVO',
    duration: 147,
    views: 4083210,
    uploadedAt: '2024-06-07T07:00:02Z',
  },
  {
    youtubeId: 'rXwMrBb2x1Q',
    title: 'The Jimi Hendrix Experience - Hey Joe (Official Audio)',
    channel: 'JimiHendrixVEVO',
    duration: 228,
    views: 42130865,
    uploadedAt: '2013-02-26T08:01:13Z',
  },
  {
    youtubeId: 'wgsGN0uXj3U',
    title:
      'Jimi Hendrix’s Intensive Practice Schedule #jimihendrix #rock #metal #fender #army #guitar',
    channel: 'The Guitar Music Channel',
    duration: 52,
    views: 326158,
    uploadedAt: '2024-08-16T18:13:24Z',
  },
  {
    youtubeId: 'WAT6KBFj6ws',
    title: 'Hendrix Chords To IMPRESS (Try this!)',
    channel: 'Guitar Mastery Method',
    duration: 59,
    views: 73364,
    uploadedAt: '2025-01-14T15:02:45Z',
  },
  {
    youtubeId: 'l5kfXmMKljc',
    title: 'Sammalhabe - Kahekestimullivannis',
    channel: 'sammalhabe',
    duration: 243,
    views: 59595,
    uploadedAt: '2018-10-28T00:19:13Z',
  },
  {
    youtubeId: 'B7TY3aVIvxs',
    title: 'Sammalhabe - Loomeinimene',
    channel: 'Mihkel P',
    duration: 248,
    views: 315890,
    uploadedAt: '2016-02-20T20:47:28Z',
  },
  {
    youtubeId: 'g6Ow2dVxsSw',
    title: 'Sammalhabe - Sõltuvuses',
    channel: 'Mihkel P',
    duration: 366,
    views: 397191,
    uploadedAt: '2016-02-25T21:07:41Z',
  },
  {
    youtubeId: '7pf600Hfaz4',
    title: 'Sammalhabe - Duubelstereotüüp',
    channel: 'sammalhabe',
    duration: 172,
    views: 12501,
    uploadedAt: '2018-09-24T17:04:59Z',
  },
  {
    youtubeId: '3JohvMffWqg',
    title: 'Kuidas Ma Muusikan + MUUSIKAVIDEO',
    channel: 'sammalhabe',
    duration: 492,
    views: 2565,
    uploadedAt: '2020-05-04T14:59:20Z',
  },
  {
    youtubeId: 'kNd1kbnLTdA',
    title: 'Loomeinimene',
    channel: 'Sammalhabe - Topic',
    duration: 248,
    views: 11842,
    uploadedAt: '2021-07-15T17:39:52Z',
  },
  {
    youtubeId: 'JExTCuum4fs',
    title: 'Sammalhabe x R.Ki -  O',
    channel: 'R.Ki',
    duration: 267,
    views: 107764,
    uploadedAt: '2015-10-08T20:34:58Z',
  },
  {
    youtubeId: 'OFoz2VXfeHM',
    title: 'Sammalhabe - Mdeamillestmaräägin',
    channel: 'sammalhabe',
    duration: 202,
    views: 8349,
    uploadedAt: '2018-11-21T14:47:33Z',
  },
  {
    youtubeId: 'qF9dKtMtOEE',
    title: 'SAMMALHABE - PLAHVATUS',
    channel: 'sammalhabe',
    duration: 160,
    views: 20286,
    uploadedAt: '2020-05-04T17:01:03Z',
  },
  {
    youtubeId: 'be8Mzrw1yMI',
    title: 'O',
    channel: 'Sammalhabe - Topic',
    duration: 285,
    views: 2690,
    uploadedAt: '2021-07-15T17:39:52Z',
  },
  {
    youtubeId: 'mSeuP56rMOc',
    title: 'Chalice - minu inimesed',
    channel: 'Jalgratastool',
    duration: 250,
    views: 706761,
    uploadedAt: '2010-02-15T12:59:50Z',
  },
  {
    youtubeId: 'gIqHBEb7-Bs',
    title: 'Chalice - Harald ja Matilda',
    channel: 'roika36',
    duration: 311,
    views: 360235,
    uploadedAt: '2012-06-19T08:03:37Z',
  },
  {
    youtubeId: '9gVUWU1aE18',
    title: 'Chalice - Preilisid on ka tegelt niisama vaadata hea',
    channel: 'vanakunn',
    duration: 281,
    views: 82867,
    uploadedAt: '2011-11-18T17:02:26Z',
  },
  {
    youtubeId: 'ICL4ZuXTrWI',
    title: 'Chalice - Mulle meeldib see',
    channel: 'lits land',
    duration: 263,
    views: 5145,
    uploadedAt: '2023-04-03T19:05:39Z',
  },
  {
    youtubeId: 'puCbXEiO0lY',
    title: 'Chalice&#39;s Hidden Gift',
    channel: 'AWESOMEHEART BEATS',
    duration: 40,
    views: 931,
    uploadedAt: '2025-05-18T15:38:27Z',
  },
  {
    youtubeId: 'aL3lmG97zx0',
    title: 'Roots &amp; Chalice',
    channel: 'Chronixx - Topic',
    duration: 253,
    views: 535808,
    uploadedAt: '2018-04-30T10:02:33Z',
  },
  {
    youtubeId: 'hTWKbfoikeg',
    title: 'Nirvana - Smells Like Teen Spirit (Official Music Video)',
    channel: 'NirvanaVEVO',
    duration: 279,
    views: 1996934963,
    uploadedAt: '2009-06-16T22:14:25Z',
  },
  {
    youtubeId: 'hEMm7gxBYSc',
    title:
      'Nirvana - Where Did You Sleep Last Night (Live On MTV Unplugged Unedited)',
    channel: 'NirvanaVEVO',
    duration: 412,
    views: 90246351,
    uploadedAt: '2019-12-21T18:00:11Z',
  },
  {
    youtubeId: 'fregObNcHC8',
    title: 'Nirvana - The Man Who Sold The World (MTV Unplugged)',
    channel: 'NirvanaVEVO',
    duration: 218,
    views: 593798253,
    uploadedAt: '2009-06-16T22:56:31Z',
  },
  {
    youtubeId: 'vabnZ9-ex7o',
    title: 'Nirvana - Come As You Are (Official Music Video)',
    channel: 'NirvanaVEVO',
    duration: 225,
    views: 614547333,
    uploadedAt: '2009-06-16T21:34:49Z',
  },
  {
    youtubeId: 'pkcJEvMcnEg',
    title: 'Nirvana - Lithium (Official Music Video)',
    channel: 'NirvanaVEVO',
    duration: 256,
    views: 299074408,
    uploadedAt: '2009-06-16T22:57:12Z',
  },
  {
    youtubeId: 'yc5hzGKnUEg',
    title: '[TOP 18] NIRVANA 2021 "Nirvana Greatest Hits"',
    channel: 'ARI MAHENDRA',
    duration: 3730,
    views: 541019,
    uploadedAt: '2018-11-24T15:42:28Z',
  },
  {
    youtubeId: '4VxdufqB9zg',
    title: 'Nirvana - Something In The Way (Audio)',
    channel: 'NirvanaVEVO',
    duration: 231,
    views: 74771348,
    uploadedAt: '2021-11-12T05:00:02Z',
  },
  {
    youtubeId: '1YhR5UfaAzM',
    title:
      'Nirvana - Something In The Way (Live On MTV Unplugged, 1993 / Unedited)',
    channel: 'NirvanaVEVO',
    duration: 489,
    views: 50885579,
    uploadedAt: '2019-12-06T18:00:01Z',
  },
  {
    youtubeId: 'AE3ynTXTm_8',
    title: 'Aneurysm',
    channel: 'Nirvana - Topic',
    duration: 276,
    views: 22105419,
    uploadedAt: '2019-07-16T20:06:07Z',
  },
  {
    youtubeId: 'PbgKEjNBHqM',
    title: 'Nirvana - In Bloom (Official Music Video)',
    channel: 'NirvanaVEVO',
    duration: 298,
    views: 177988052,
    uploadedAt: '2009-06-16T22:25:12Z',
  },
  {
    youtubeId: 'aWmkuH1k7uA',
    title: 'Nirvana - All Apologies (MTV Unplugged)',
    channel: 'NirvanaVEVO',
    duration: 220,
    views: 104768786,
    uploadedAt: '2009-06-17T01:36:28Z',
  },
  {
    youtubeId: 'JIx2H-plXdU',
    title: 'About A Girl (Remastered)',
    channel: 'Nirvana - Topic',
    duration: 169,
    views: 21871050,
    uploadedAt: '2019-03-23T01:31:05Z',
  },
  {
    youtubeId: 'Ba_08WWIWV8',
    title: 'All Apologies',
    channel: 'Nirvana - Topic',
    duration: 234,
    views: 30301712,
    uploadedAt: '2018-07-26T20:29:01Z',
  },
  {
    youtubeId: 'qv96yJYhk3M',
    title: "Nirvana - You Know You're Right (LP Version)",
    channel: 'NirvanaVEVO',
    duration: 222,
    views: 113975297,
    uploadedAt: '2009-12-25T01:05:48Z',
  },
  {
    youtubeId: 'iywaBOMvYLI',
    title: 'System Of A Down - Toxicity (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 225,
    views: 1047756624,
    uploadedAt: '2009-10-02T15:16:02Z',
  },
  {
    youtubeId: 'CSvFpBOe8eY',
    title: 'System Of A Down - Chop Suey! (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 209,
    views: 1474347644,
    uploadedAt: '2009-10-03T04:45:02Z',
  },
  {
    youtubeId: 'L-iepu3EtyE',
    title: 'System Of A Down - Aerials (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 244,
    views: 503870469,
    uploadedAt: '2009-10-03T04:51:24Z',
  },
  {
    youtubeId: 'zUzd9KyIDrM',
    title: 'System Of A Down - B.Y.O.B. (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 263,
    views: 493693669,
    uploadedAt: '2009-10-03T04:50:13Z',
  },
  {
    youtubeId: 'DnGdoEa1tPg',
    title: 'System Of A Down - Lonely Day (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 172,
    views: 410553129,
    uploadedAt: '2009-10-03T07:35:20Z',
  },
  {
    youtubeId: '5vBGOrI6yBk',
    title: 'System Of A Down - Sugar (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 211,
    views: 136281598,
    uploadedAt: '2009-10-03T04:48:23Z',
  },
  {
    youtubeId: 'eudOwe3Rz-0',
    title: 'System Of A Down - I-E-A-I-A-I-O (Official Audio)',
    channel: 'systemofadownVEVO',
    duration: 191,
    views: 14097525,
    uploadedAt: '2021-03-19T07:00:32Z',
  },
  {
    youtubeId: 'LoheCz4t2xc',
    title: 'System Of A Down - Hypnotize (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 229,
    views: 219148547,
    uploadedAt: '2009-10-03T04:48:15Z',
  },
  {
    youtubeId: 'DmmYAX8Phig',
    title: 'System Of A Down - Radio/Video (Official Audio)',
    channel: 'systemofadownVEVO',
    duration: 251,
    views: 17537721,
    uploadedAt: '2021-03-26T07:00:03Z',
  },
  {
    youtubeId: '27G-wokE3TQ',
    title: 'System Of A Down - Chop Suey',
    channel: 'blackheartedsoab',
    duration: 211,
    views: 13025424,
    uploadedAt: '2007-05-16T17:52:34Z',
  },
  {
    youtubeId: 'SqZNMvIEHhs',
    title: 'System Of A Down - Spiders (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 216,
    views: 135704608,
    uploadedAt: '2009-10-03T04:47:13Z',
  },
  {
    youtubeId: 'ENBv2i88g6Y',
    title: 'System Of A Down - Question! (Official HD Video)',
    channel: 'systemofadownVEVO',
    duration: 229,
    views: 110082830,
    uploadedAt: '2009-10-03T04:49:03Z',
  },
  {
    youtubeId: 'gOsILsG8llQ',
    title: 'System Of A Down - Toxicity (lyrics)',
    channel: 'Wind Music',
    duration: 223,
    views: 3009263,
    uploadedAt: '2022-03-31T09:57:15Z',
  },
  {
    youtubeId: '22tVWwmTie8',
    title: 'Eminem - Houdini [Official Music Video]',
    channel: 'EminemVEVO',
    duration: 297,
    views: 235466023,
    uploadedAt: '2024-05-31T04:00:02Z',
  },
  {
    youtubeId: 'S9bCLPwzSC0',
    title: 'Eminem - Mockingbird [Official Music Video]',
    channel: 'EminemVEVO',
    duration: 258,
    views: 1246284071,
    uploadedAt: '2009-12-25T04:20:46Z',
  },
  {
    youtubeId: '9adAEAu5xVM',
    title: 'Jarek Kasar - Klaaskuulis (official video)',
    channel: 'Lynda Kunda',
    duration: 238,
    views: 191428,
    uploadedAt: '2012-03-06T19:05:07Z',
  },
  {
    youtubeId: 'CzNA614MvMw',
    title: 'Jarek Kasar (Chalice) - Kirsti elab Reykjavikis',
    channel: 'Art Pro',
    duration: 264,
    views: 23938,
    uploadedAt: '2013-05-27T15:21:17Z',
  },
  {
    youtubeId: 'ZJGa7z9Z6bU',
    title: 'Jarek Kasar MINU INIMESED X Noorte Laulupidu',
    channel: 'Raudne',
    duration: 321,
    views: 9085,
    uploadedAt: '2024-02-23T19:33:49Z',
  },
  {
    youtubeId: 'TIXV7KD9gPw',
    title: 'Eestimaa uhkus 2025 Jarek Kasar Minu inimesed',
    channel: 'TV3 Eesti / TV3 Estonia',
    duration: 285,
    views: 111,
    uploadedAt: '2025-03-11T10:55:47Z',
  },
  {
    youtubeId: '3aamlRXr0WQ',
    title: 'Rapla - Esimene kord - Jarek Kasar &amp; Vaiko Eplik',
    channel: 'Eesti Live',
    duration: 206,
    views: 14474,
    uploadedAt: '2022-04-11T13:06:56Z',
  },
  {
    youtubeId: 'r8cLn43RnVM',
    title: 'Aida sessioonid / Episood 2 / Jarek Kasar - Tõepoolest armastus',
    channel: 'Eesti Pärimusmuusika Keskus',
    duration: 163,
    views: 2001,
    uploadedAt: '2019-09-03T10:46:19Z',
  },
  {
    youtubeId: 'YlUKcNNmywk',
    title:
      'Red Hot Chili Peppers - Californication (Official Music Video) [HD UPGRADE]',
    channel: 'Red Hot Chili Peppers',
    duration: 322,
    views: 1244881325,
    uploadedAt: '2009-10-27T02:35:59Z',
  },
  {
    youtubeId: '8DyziWtkfBw',
    title: 'Red Hot Chili Peppers - Can&#39;t Stop [Official Music Video]',
    channel: 'Red Hot Chili Peppers',
    duration: 278,
    views: 424964132,
    uploadedAt: '2009-10-27T02:33:12Z',
  },
  {
    youtubeId: 'Q0oIoR9mLwc',
    title: 'Red Hot Chili Peppers - Dark Necessities [Official Music Video]',
    channel: 'Red Hot Chili Peppers',
    duration: 304,
    views: 514096337,
    uploadedAt: '2016-06-17T17:00:40Z',
  },
  {
    youtubeId: 'GLvohMXgcBo',
    title: 'Red Hot Chili Peppers - Under The Bridge [Official Music Video]',
    channel: 'Red Hot Chili Peppers',
    duration: 268,
    views: 318140004,
    uploadedAt: '2009-10-27T02:32:53Z',
  },
  {
    youtubeId: 'adjrBMFudgE',
    title:
      'Red Hot Chili Peppers Greatest Hits | Best Songs of the Red Hot Chili Peppers Full Album',
    channel: 'Rockzilla',
    duration: 1763,
    views: 830495,
    uploadedAt: '2025-04-25T13:02:24Z',
  },
  {
    youtubeId: 'mzJj5-lubeM',
    title:
      'Red Hot Chili Peppers - Scar Tissue [Official Music Video] [HD UPGRADE]',
    channel: 'Red Hot Chili Peppers',
    duration: 221,
    views: 560013800,
    uploadedAt: '2011-07-15T22:26:46Z',
  },
  {
    youtubeId: 'rn_YodiJO6k',
    title:
      'Red Hot Chili Peppers - Otherside [Official Music Video] [HD UPGRADE]',
    channel: 'Red Hot Chili Peppers',
    duration: 258,
    views: 841653421,
    uploadedAt: '2011-07-15T22:26:46Z',
  },
  {
    youtubeId: 'Sb5aq5HcS1A',
    title: 'Red Hot Chili Peppers - Dani California [Official Music Video]',
    channel: 'Red Hot Chili Peppers',
    duration: 288,
    views: 384517199,
    uploadedAt: '2009-10-27T02:33:19Z',
  },
  {
    youtubeId: '0fcRa5Z6LmU',
    title: 'Red Hot Chili Peppers - The Zephyr Song [Official Music Video]',
    channel: 'Red Hot Chili Peppers',
    duration: 232,
    views: 130435344,
    uploadedAt: '2009-10-27T02:33:05Z',
  },
];
